import React from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-lg font-semibold text-[#1C4358] mb-2">{title}</h2>
    <div className="text-[15px] leading-relaxed text-[#3a4551] space-y-3">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-5 py-14" data-testid="terms-page">
      <div className="flex items-center gap-2 mb-2 text-[#1C4358]"><FileText size={20} /><span className="text-sm font-medium uppercase tracking-wide">Terms</span></div>
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#252221] mb-3">Terms of Use</h1>
      <p className="text-[14px] text-[#6b7480] mb-8">Placeholder terms describing acceptable use of MovingMyMama. Please have these reviewed by qualified counsel before launch.</p>

      <Section title="Using this platform">
        <p>By using MovingMyMama, you agree to use it lawfully and to provide accurate information. The platform helps families coordinate senior transition support and connects them with our team and, where appropriate, vetted professionals and partners.</p>
      </Section>

      <Section title="No professional guarantees">
        <p>MovingMyMama offers guidance and coordination. We do not provide medical, legal, financial, tax, or real-estate advice, and we do not guarantee any specific outcome — including care, placement, home-sale, financial, or timing outcomes. Always consult the appropriate licensed professional before making decisions.</p>
      </Section>

      <Section title="Professional review">
        <p>Content, summaries, and recommendations surfaced in the platform — including AI-assisted drafts — are informational aids. They must be reviewed by a qualified person or professional before you rely on them.</p>
      </Section>

      <Section title="Your responsibilities">
        <p>You are responsible for the accuracy of information you submit, for maintaining the confidentiality of your account, and for the documents you choose to share. Do not upload content you do not have the right to share.</p>
      </Section>

      <Section title="Communications">
        <p>By requesting a consultation or service, you agree we may contact you about your request. Marketing communications are optional and can be turned off at any time. See our <Link to="/privacy" className="text-[#9C1E22] underline">Privacy Policy</Link>.</p>
      </Section>

      <Section title="Changes">
        <p>We may update these terms as the platform evolves. Continued use after an update means you accept the revised terms.</p>
      </Section>

      <p className="text-[13px] text-[#8a8f98] mt-10">Questions? <Link to="/contact" className="underline">Contact us</Link>.</p>
    </div>
  );
}
